//init
import * as Realm from 'realm-web';
const app = new Realm.App({ id: process.env.REACT_APP_MNDB_RELM_USER});


export const AuthCodeUser = async () => {
  const cred = Realm.Credentials.apiKey(process.env.REACT_APP_MNDB_AUTH_USER);
  const user = await app.logIn(cred);
  return user
}


// onboard new user - step 1 (name)
export const NewContactPerson = async (item) => {
  const authuser = await AuthCodeUser()
  const result = await authuser.functions.contCreatePerson(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

export const NewContactTeam = async (item) => {
  const authuser = await AuthCodeUser()
  const result = await authuser.functions.contCreateTeam(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

export const NewContactBusiness = async (item) => {
  const authuser = await AuthCodeUser()
  const result = await authuser.functions.contCreateBusiness(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

// ------------------------ //
export const GetContactsList = async (item) => {
  const authuser = await AuthCodeUser()
  const result = await authuser.functions.contGetContactsList(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

export const GetContactsCount = async (item) => {
  const authuser = await AuthCodeUser()
  const result = await authuser.functions.contGetContactsCount(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}
